import { apiSlice } from "./apiSlice";
import { NotificationActions } from "./notificationSlice";

export const procedureSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getTopProcedures: builder.query({
            query: ({ hospitalId, cardCostVariance, caseCostVariance }) => {
                let query = `/hospitals/${hospitalId}/procedures`;
                const params = [];
                if (cardCostVariance) params.push('card_cost_variance=1');
                if (caseCostVariance) params.push('case_cost_variance=1');
                if (params.length) query += `?${params.join('&')}`;
                return query;
            },
        }),
        getProcedureRollupSummary: builder.query({
            query: (procedureId) => ({
                url: `/procedures/${procedureId}/rollupSummary`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: 'ProcedureRollupSummary', id: arg }]
        }),
        getProcedureItemInsights: builder.query({
            query: (procedureId) => ({
                url: `/procedures/${procedureId}/itemInsightsFacts`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: 'ProcedureItemInsights', id: arg }]
        }),
        getProcedureInsights: builder.query({
            query: (procedureId) => `/procedures/${procedureId}/insights`,
            providesTags: (result, error, arg) => [{ type: 'ProcedureInsights', id: arg }]
        }),
        getHospitalProcedureInsights: builder.query({
            query: (hospitalId) => `/hospitals/${hospitalId}/procedureInsights`,
            providesTags: (result, error, arg) => [{ type: 'HospitalProcedureInsights', id: arg }]
        }),
        getProcedureItemUsageTrends: builder.query({
            query: ({ procedureId, itemId }) => ({
                url: `/procedures/${procedureId}/items/${itemId}`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: 'ProcedureItemUsageTrends', id: arg }]
        }),
        getProcedureItems: builder.query({
            query: (procedureId) => ({
                url: `/procedures/${procedureId}/items`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: 'ProcedureItems', id: arg }]
        }),
        getProcedure: builder.query({
            query: (procedureId) => ({
                url: `/procedures/${procedureId}`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: 'Procedure', id: arg }]
        }),
        getProcedureCards: builder.query({
            query: (procedureId) => ({
                url: `/procedures/${procedureId}/cards`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: 'ProcedureCards', id: arg }]
        }),
        getAverageProcedureSpend: builder.query({
            query: ({ procedureId, start_date, end_date, interval }) => {
                const params = new URLSearchParams();
                if (start_date) params.append('start_date', start_date);
                if (end_date) params.append('end_date', end_date);
                if (interval) params.append('interval', interval);
                const qs = params.size ? `?${params.toString()}` : '';
                return {
                    url: `/procedures/${procedureId}/averageSpend${qs}`,
                    method: 'GET'
                };
            },
            providesTags: (result, error, arg) => [{ type: 'AverageProcedureSpend', id: arg.procedureId }]
        }),
    })
});

export const {
    useGetTopProceduresQuery,
    useGetProcedureRollupSummaryQuery,
    useGetProcedureItemInsightsQuery,
    useGetProcedureInsightsQuery,
    useGetHospitalProcedureInsightsQuery,
    useGetProcedureItemUsageTrendsQuery,
    useGetProcedureItemsQuery,
    useGetProcedureQuery,
    useGetProcedureCardsQuery,
    useGetAverageProcedureSpendQuery,
} = procedureSlice;
